import { PermissionActions } from '@/features/permissions/permissionActions.js'
import { SuperAdminLimitedLogsViewActions } from '@/features/superAdmin/logsManagement/superAdminLogsNavigation.js'

export { SuperAdminLimitedLogsViewActions }

export const SuperAdminLimitedMasterViewActions = Object.freeze([
  PermissionActions.SuperAdminLimitedMasterBrandsView,
  PermissionActions.SuperAdminLimitedMasterComponentsView,
  PermissionActions.SuperAdminLimitedMasterCountriesView,
  PermissionActions.SuperAdminLimitedMasterSportCategoriesView,
  PermissionActions.SuperAdminLimitedMasterTenantDefinitionsView,
  PermissionActions.SuperAdminLimitedMasterTerminologiesView,
  PermissionActions.SuperAdminLimitedMasterProfileOrganizationRolesView,
  PermissionActions.SuperAdminLimitedMasterSportTypesView,
  PermissionActions.SuperAdminLimitedMasterOsiAccessModulesView,
])

export const SuperAdminLimitedOASystemNavigationActions = Object.freeze([
  PermissionActions.SuperAdminLimitedOASystemTable,
])

export const SuperAdminLimitedRootViewActions = Object.freeze([
  PermissionActions.SuperAdminLimitedClubsView,
  PermissionActions.SuperAdminLimitedDashboardView,
  PermissionActions.SuperAdminLimitedPeopleView,
  PermissionActions.SuperAdminLimitedRolesView,
  ...SuperAdminLimitedMasterViewActions,
  PermissionActions.SuperAdminLimitedGlobalSiteThemesView,
  ...SuperAdminLimitedLogsViewActions,
  ...SuperAdminLimitedOASystemNavigationActions,
])
